import { SlotGameType1_21 } from '../SlotGameType1_21';

export class LuckyIce2021 extends SlotGameType1_21
{
}
